import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { TestService } from '../../services/test.service';

@Component({
  selector: 'ispm-curation-navigation-vertical-container',
  templateUrl: './curation-navigation-vertical-container.component.html',
  styleUrls: ['./curation-navigation-vertical-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CurationNavigationVerticalContainerComponent implements OnInit {
  verticalTestActionsView: boolean;

  constructor(
    private testService : TestService
  ) { }

  ngOnInit() {
    this.verticalTestActionsView = this.testService.testConfiguration
      && !!this.testService.testConfiguration.VerticalTestActionsView;
  }

}
